import React, { useMemo, useState } from 'react'
import '../../../styles/analytics/StudentAnalytics.css'
import { detailedEmotionsDummy } from '../../../constants/StudentAnalyticsConstants'
import ReactTooltip from 'react-tooltip'
import { emotions_heads } from '../../../constants/Constants'
import { LoadingContainer } from './CheckInWidget'
import EmotionBarTooltip from './EmotionBarTooltip'
import WellBeingAsignModal from '../../modals/WellBeingAsignModal'
import WellBeingTakeActionModal from '../../modals/WellBeingTakeActionModal'

function BarChartDetails({ height = 200, data, loading, student }) {
    const showLoading = useMemo(() => loading || !data, [loading, data])

    const usedData = useMemo(() => {
        return data == null ? detailedEmotionsDummy : data
    }, [data])

    const allValues = usedData?.map((e) => e?.feedback?.length ?? 0) ?? []
    const maxValue = Math.ceil(Math.max(...allValues, 1))
    const numberOfHorizontalLines = maxValue + 1
    const horizontalLines = Array(numberOfHorizontalLines)?.fill('1')
    return (
        <div className="relative">
            <DataContainer height={height} horizontalLines={horizontalLines} maxValue={maxValue} newList={usedData} blur={showLoading} student={student} />
            {showLoading && <LoadingContainer height={height} showEmptyData={!loading && !data} />}
        </div>
    )
}

export default BarChartDetails

const DataContainer = ({ height, horizontalLines, newList, maxValue, blur, student }) => {
    return (
        <div className={`flex flex-row mt-5 w-full pb-[5px] ${blur ? 'blur' : ''}`} style={{ minHeight: height }}>
            <div className="w-[22px]">
                <div className="flex flex-col-reverse w-full gap-[1px] justify-between h-full">
                    {horizontalLines?.map((item, index) => (
                        <div className={`flex flex-col w-full `} style={{ minHeight: 20 }} key={index}>
                            <p className="text-[12px] leading-5 text-darkenPurple font-medium ">{index}</p>
                        </div>
                    ))}
                </div>
            </div>
            <div className="flex-1 relative " style={{ scrollbarColor: '#9392AD transparent' }}>
                <div
                    className="h-full py-[9px]"
                    style={{
                        minWidth: '100%',
                    }}
                >
                    <div className="flex flex-col items-center w-full gap-[1px] h-full  justify-between " style={{ minHeight: height }}>
                        {horizontalLines?.map((item, index) => (
                            <div key={index} className="border-dashed border-b border-b-[#ECEBF8] w-full" style={{ height: 1, width: '100%' }} />
                        ))}
                    </div>
                </div>
                <div className="flex flex-row items-end absolute top-0 left-0 z-[3] w-full justify-between py-[10px]">
                    {newList?.map((item, index) => (
                        <BarChartItem height={height} item={item} maxValue={maxValue} key={index} index={index} student={student} />
                    ))}
                </div>
            </div>
        </div>
    )
}

const BarChartItem = ({ height, item, maxValue, index, student }) => {
    return (
        <div className="min-w-[60px] max-w-[128px]">
            <div className=" w-full flex flex-col justify-end" style={{ minHeight: height }}>
                {item.feedback?.map((barItem, barIndex) => (
                    <BarChartSingleEmotion
                        height={height}
                        item={barItem}
                        maxValue={maxValue}
                        key={barIndex}
                        barIndex={barIndex}
                        index={index}
                        student={student}
                        isLast={index === item.feedback.length - 1}
                    />
                ))}
                {!item.feedback?.length && <NoBarResults height={height} />}
            </div>
            <div className=" w-full h-[32px] flex items-center justify-center ">
                <p className="text-[14px] leading-5 text-mediumGray text-center font-medium tracking-tighter">{item?.label_name}</p>
            </div>
        </div>
    )
}
const BarChartSingleEmotion = ({ height, item, maxValue, barIndex, index, student, isLast }) => {
    const [showValue, setShowValue] = useState(false)
    const [showAssignActionModal, setShowAssignActionModal] = useState(false)
    const [showTakeActionModal, setShowTakeActionModal] = useState(false)

    const openAssignActionModal = () => setShowAssignActionModal(true)
    const closeAssignActionModal = () => setShowAssignActionModal(false)

    const openTakeActionModal = () => setShowTakeActionModal(true)
    const closeTakeActionModal = () => setShowTakeActionModal(false)

    return (
        <>
            <button
                onMouseEnter={() => setShowValue(true)}
                onMouseLeave={() => {
                    setShowValue(false)
                    ReactTooltip.hide()
                }}
                className="w-full rounded-[20px]  relative flex items-center justify-center transition-[230ms] max-w-[60px] self-center mb-[1px] max-h-[120px]"
                style={{
                    backgroundColor: item.comfortable ? '#6FCC8766' : '#FD9AA166',
                    height: height / maxValue - 1,
                    minHeight: 20,
                }}
                data-tip="hello"
                data-for={`imageTooltip${index}barIndex${barIndex}`}
            >
                <div className={`flex items-center justify-center rounded-full  transition-[230ms] h-full text-white ${showValue ? 'opacity-100' : 'opacity-0'}`}>
                    <img src={emotions_heads[item?.emotion]} style={{ objectFit: 'contain', maxHeight: '80%', width: '100%', maxWidth: 35 }} alt="emotion" />
                </div>
                <EmotionBarTooltip
                    id={`imageTooltip${index}barIndex${barIndex}`}
                    item={item}
                    assignAction={openAssignActionModal}
                    takeAction={openTakeActionModal}
                    place={isLast ? 'left' : 'right'}
                />
            </button>
            <WellBeingAsignModal modalIsOpen={showAssignActionModal} closeModal={closeAssignActionModal} student={student} note={item} />
            <WellBeingTakeActionModal modalIsOpen={showTakeActionModal} closeModal={closeTakeActionModal} student={student} note={item} />
        </>
    )
}

export const NoBarResults = ({ height }) => {
    return (
        <div
            className="flex items-center justify-center striped-background max-w-[60px] self-center"
            style={{
                width: '100%',
                height: height - 1,
                borderRadius: 20,
                marginBottom: 1,
            }}
        >
            <p className="text-[14px] text-nowrap leading-5 text-mediumGray font-medium text-center -rotate-90">no logged emotion</p>
        </div>
    )
}
